"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conversionsChart = void 0;
const helper_1 = require("./helper");
const conversionsChart = (dateRange, filters, granularity) => (0, helper_1.getChartQuery)(['Conversions.count'], dateRange, filters, undefined, undefined, 'Conversions.conversionTime', granularity);
exports.conversionsChart = conversionsChart;
//# sourceMappingURL=conversions.js.map